import { useCallback, useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { Show, UserButton } from "@clerk/react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { LOGO_URL } from "../lib/api";
import { BiniBubble } from "../components/Bini";
import { useAdminApi } from "../components/admin/useAdminApi";
import { SongsTab } from "../components/admin/SongsTab";
import { ThemesTab } from "../components/admin/ThemesTab";
import { DailyTab } from "../components/admin/DailyTab";
import { UsersTab } from "../components/admin/UsersTab";
import { AssetsTab } from "../components/admin/AssetsTab";
import { PagesTab, MessagesTab, NewsletterTab } from "../components/admin/SiteTabs";
import { OrdersTab } from "../components/admin/OrdersTab";

const Dashboard = () => {
  const call = useAdminApi();
  const [me, setMe] = useState(null);
  const [songs, setSongs] = useState([]);
  const [themes, setThemes] = useState([]);

  const reload = useCallback(() => {
    call("get", "/admin/songs").then(setSongs).catch(() => {});
    call("get", "/themes").then(setThemes).catch(() => {});
  }, [call]);

  useEffect(() => { call("get", "/me").then(setMe).catch(() => setMe({ role: "none" })); }, [call]);
  useEffect(() => { if (me?.role === "admin") reload(); }, [me, reload]);

  if (!me) return null;
  if (me.role !== "admin") return (
    <div className="mt-10 space-y-6">
      <BiniBubble testId="admin-forbidden">Cet espace est réservé à l'administratrice du site.</BiniBubble>
      <Link to="/" data-testid="admin-forbidden-home-btn" className="btn-3d" style={{ "--c": "#38B6FF" }}>Retour à l'accueil</Link>
    </div>
  );

  return (
    <Tabs defaultValue="songs" className="mt-6">
      <TabsList className="flex h-auto flex-wrap justify-start gap-1 rounded-[20px] bg-white/80 p-1.5">
        <TabsTrigger value="songs" data-testid="admin-tab-songs" className="rounded-full">Comptines</TabsTrigger>
        <TabsTrigger value="themes" data-testid="admin-tab-themes" className="rounded-full">Thèmes</TabsTrigger>
        <TabsTrigger value="daily" data-testid="admin-tab-daily" className="rounded-full">Comptine du jour</TabsTrigger>
        <TabsTrigger value="colorings" data-testid="admin-tab-colorings" className="rounded-full">Coloriages</TabsTrigger>
        <TabsTrigger value="packs" data-testid="admin-tab-packs" className="rounded-full">Packs payants</TabsTrigger>
        <TabsTrigger value="orders" data-testid="admin-tab-orders" className="rounded-full">Commandes</TabsTrigger>
        <TabsTrigger value="pages" data-testid="admin-tab-pages" className="rounded-full">Pages légales</TabsTrigger>
        <TabsTrigger value="messages" data-testid="admin-tab-messages" className="rounded-full">Messages</TabsTrigger>
        <TabsTrigger value="newsletter" data-testid="admin-tab-newsletter" className="rounded-full">Newsletter</TabsTrigger>
        <TabsTrigger value="users" data-testid="admin-tab-users" className="rounded-full">Utilisateurs</TabsTrigger>
      </TabsList>
      <TabsContent value="songs" className="mt-5"><SongsTab songs={songs} themes={themes} call={call} reload={reload} /></TabsContent>
      <TabsContent value="themes" className="mt-5"><ThemesTab themes={themes} call={call} reload={reload} /></TabsContent>
      <TabsContent value="daily" className="mt-5"><DailyTab songs={songs} call={call} /></TabsContent>
      <TabsContent value="colorings" className="mt-5"><AssetsTab kind="colorings" themes={themes} songs={songs} call={call} /></TabsContent>
      <TabsContent value="packs" className="mt-5"><AssetsTab kind="packs" themes={themes} songs={songs} call={call} /></TabsContent>
      <TabsContent value="orders" className="mt-5"><OrdersTab call={call} /></TabsContent>
      <TabsContent value="pages" className="mt-5"><PagesTab call={call} /></TabsContent>
      <TabsContent value="messages" className="mt-5"><MessagesTab call={call} /></TabsContent>
      <TabsContent value="newsletter" className="mt-5"><NewsletterTab call={call} /></TabsContent>
      <TabsContent value="users" className="mt-5"><UsersTab call={call} /></TabsContent>
    </Tabs>
  );
};

export default function Admin() {
  return (
    <div className="min-h-[100dvh] bg-[#EAF6FF] text-[#1E2A5A]">
      <div className="mx-auto max-w-4xl px-4 py-6 sm:px-8">
        <header className="flex items-center gap-3">
          <img src={LOGO_URL} alt="MIZUBINI" className="h-14 w-14 rounded-2xl border-4 border-white shadow" />
          <h1 className="flex-1 text-2xl sm:text-3xl font-extrabold">Administration</h1>
          <Show when="signed-in"><UserButton /></Show>
        </header>
        <Show when="signed-in"><Dashboard /></Show>
        <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
      </div>
    </div>
  );
}
